import { TasksInformationSchema } from '../model/types/tasksInformationSchema';

export const getTabsOfGrouper = (tabsListObj: TasksInformationSchema['tabs']['list']) => {
    if (!tabsListObj) return [];

    const tabsArray = Object.keys(tabsListObj);
    if (tabsArray.length === 0) {
        return [];
    }

    const priorities: Record<string, number> = {
        completed: 0,
        no_term: 1,
    };

    return tabsArray.sort((a, b) => {
        const priorityA = priorities[a] ?? 2;
        const priorityB = priorities[b] ?? 2;
        return priorityA - priorityB;
    });
};
